// Components==============
import { useStorage } from 'hooks/useStorage';
import React, { createContext, useMemo } from 'react';
// =========================

type GlobalSideNavContextType = {
  sideNavIsOpen: boolean;
  setSideNavIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalSideNavContext = createContext(
  {} as GlobalSideNavContextType
);

export default function GlobalSideNav({
  children,
}: {
  children: React.ReactNode;
}) {
  const [sideNavIsOpen, setSideNavIsOpen] = useStorage('sideNavIsOpen', true);

  const value = useMemo(() => ({ sideNavIsOpen, setSideNavIsOpen }), [
    sideNavIsOpen,
  ]);

  return (
    <GlobalSideNavContext.Provider value={value}>
      {children}
    </GlobalSideNavContext.Provider>
  );
}
